<default-slider></default-slider>
<!-- <default-now-sell></default-now-sell> -->
<default-catalog></default-catalog>
<default-module></default-module>

<default-services></default-services>
<default-mobile-app></default-mobile-app>